<template>
  <div class>
    <el-dialog :title="addEditTitle" :visible.sync="addEditShow" width="480px" :before-close="handleChangeDrawer" :close-on-click-modal='false'>
        <div class="pay-mains">
          <el-form ref="form" :model="form" class="demo-ruleForm card-ruleForm" label-width="100px">
            <el-form-item ref="mobile" label="手机号码：" prop="mobile" class="flex-row">{{form.mobile}}</el-form-item>
            <el-form-item ref="verifyCode" label="验证码：" prop="verifyCode" :rules="$rules.required" class="flex-row">
              <div class="sms-input">
                <el-input placeholder="输入验证码" :maxlength="6" v-model="form.verifyCode"></el-input>
                <el-link type="primary" :underline="false" class="sms-code" @click="addLoginCode" :disabled="!codeName">{{ codeName ? '发送验证码':time+'s'}}</el-link>
              </div>
            </el-form-item>
            <el-form-item ref="newPassword" label="新密码：" prop="newPassword" :rules="$rules.required" class="flex-row">
              <el-input v-model.trim="form.newPassword" type="password" placeholder="请输入密码" maxlength="6"></el-input>
            </el-form-item>
            <el-form-item ref="comfirmPassword" label="确认密码：" prop="comfirmPassword" class="flex-row" :rules="$rules.required">
              <el-input v-model.trim="form.comfirmPassword" type="password" placeholder="请再次输入密码" maxlength="6"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="back">取消</el-button>
          <el-button type="primary" @click="onSubmit">确定修改</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import minxin from "../../assets/javascript/minxin.js";
import drawer from "../../components/common/drawer";
import { decrypt, encrypt } from "../../assets/javascript/untils";
export default {
  mixins: [minxin],
  components: { drawer },
  data() {
    return {
      codeName: true,
      time: 60,
      addEditTitle: "修改密码",
      addEditShow: false,
      form: {
        memberId: "",
        mobile: ""
      },
      columns: [],
      staffList: [],
      cardOldName: "",
      showPicker: false
    };
  },
  created() {
    this.editInit();
  },
  methods: {
    back() {
      this.addEditShow = false;
      this.$refs['form'].resetFields()
    },
    editInit() {
      this.$on("set", function(org) {
        Object.assign(this.$data, this.$options.data());
        this.form.memberId = org.id;
        this.form.mobile = org.mobile;
        this.addEditShow = true;
      });
    },
    handleChangeDrawer() {
      this.addEditShow = false;
      this.$emit("change", false);
    },
    addLoginCode() {
    //   if (this.form.mobile == "") {
    //     this.$message.error("请输入手机号码");
    //     return false;
    //   }
    //   if (this.form.mobile.length != 11) {
    //     this.$message.error("请输入正确的手机号码");
    //     return false;
    //   }
      let arr = encrypt(
        JSON.stringify({
          mobile: this.form.mobile,
          bizType: "changeloginpwd",
          millisecond: new Date().getTime()
        })
      );
      this.$api.post(this.$url.send, arr).then(resp => {
        if (resp) {
            this.$message.success("短信发送成功")
          this.codeName = false;
        } else {
          this.codeName = true;
          clearInterval(auth_timetimer);
        }
        this.time = 60;
      });
      let auth_timetimer = setInterval(() => {
        if (this.time <= 0) {
          this.time = 60;
          this.codeName = true;
          clearInterval(auth_timetimer);
        }
        this.time--;
      }, 1000);
    },
    onSubmit(values) {
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          if (this.form.newPassword != this.form.comfirmPassword) {
            return this.$message.error("两次密码不一致")
          }
          this.$api.post(
              this.$url.member.changeMemberPwd,
              encrypt(JSON.stringify(this.form))
            )
            .then(res => {
              if (res) {
                this.addEditShow = false;
                this.$message.success("操作成功");
                this.$emit("change", true);
              }
            })
            .catch(error => {});
        }
      });
    }
  }
};
</script>
<style scoped lang="less">
@import "../../assets/css/edit.less";
.sms-input {
  position: relative;
  .sms-code {
    position: absolute;
    right: 10px;
  }
}
</style>